import Hero from '../../components/Hero';
import NewsScroller from '../../components/NewsScroller';
import ProgramPreview from '../../components/ProgramPreview';
import { HomeContainer, Mission, Stats, StatItem } from './styles';

const Home = () => {
  return (
    <HomeContainer>
      <Hero />
      <NewsScroller />
      <Mission>
        <div className="container">
          <h2>Notre Mission</h2>
          <p>
            CODHOD s'engage à promouvoir les droits de l'homme et le développement durable
            à travers une approche participative et inclusive. Notre objectif est de construire
            une société plus juste où chaque individu peut vivre dignement.
          </p>
        </div>
      </Mission>
      <Stats>
        <div className="container">
          <StatItem>
            <h3>1000+</h3>
            <p>Personnes aidées</p>
          </StatItem>
          <StatItem>
            <h3>50+</h3>
            <p>Projets réalisés</p>
          </StatItem>
          <StatItem>
            <h3>20+</h3>
            <p>Partenaires</p>
          </StatItem>
          <StatItem>
            <h3>10+</h3>
            <p>Années d'expérience</p>
          </StatItem>
        </div>
      </Stats>
      <ProgramPreview />
    </HomeContainer>
  );
};

export default Home;